// AI Generated Test
import { Component, OnInit, Input } from '@angular/core';
import { AccessibilityDoughnutChartService } from '@client/app/blocks/service/charts/accessibility-doughnut-chart.service';

@Component({
    selector: 'accessibility-dashboard-doughnut',
    standalone: false,
    template: `
        <mon-chart-doughnut [size]="'500'"
                        class="accessibility-dashboard-doughnut"
                        [colors]="colors"
                        [options]="options"
                        [data]="data"
                        [labels]="labels">
        </mon-chart-doughnut>
    `,
})
export class AccessibilityDashboardDoughnutComponent implements OnInit {
    @Input() data: any;
    @Input() options: any;

    labels: any;
    colors: any;

    constructor (private accessibilityDoughnutChartService: AccessibilityDoughnutChartService) {}

    ngOnInit (): void {
        const chartService = this.accessibilityDoughnutChartService.init(null, null);
        this.labels = chartService.getLabels();
        this.colors = chartService.getColors();
    }
}
